import React from 'react'
import { Badge, Tag, Space, Typography } from 'antd'
import { ClockCircleOutlined, UserOutlined } from '@ant-design/icons'

const { Text } = Typography

// Format status with badge
export const getStatusBadge = (status) => {
  let statusProps
  switch (status) {
    case 'Completed':
      statusProps = { status: 'success', text: 'Completed' }
      break
    case 'In Progress':
      statusProps = { status: 'processing', text: 'In Progress' }
      break
    case 'Scheduled':
      statusProps = { status: 'default', text: 'Scheduled' }
      break
    case 'Cancelled':
      statusProps = { status: 'error', text: 'Cancelled' }
      break
    default:
      statusProps = { status: 'default', text: status }
  }
  return <Badge {...statusProps} />
}

// Format date and time
export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return '-'
  const dateTime = new Date(dateTimeString)
  return dateTime.toLocaleString([], {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

// Format time only
export const formatTime = (dateTimeString) => {
  if (!dateTimeString) return '-'
  const dateTime = new Date(dateTimeString)
  return dateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

// Calculate and format duration between start and end times
export const getDuration = (startDateTime, endDateTime) => {
  if (!startDateTime || !endDateTime) return '-'

  const start = new Date(startDateTime)
  const end = new Date(endDateTime)
  const diffMinutes = Math.round((end - start) / (1000 * 60))

  if (diffMinutes < 60) {
    return `${diffMinutes} min`
  } else {
    const hours = Math.floor(diffMinutes / 60)
    const minutes = diffMinutes % 60
    return `${hours}h ${minutes > 0 ? `${minutes}m` : ''}`
  }
}

// Format person info with name and ID
export const formatPersonInfo = (name, id) => (
  <Space direction='vertical' size={0}>
    <Text>{name}</Text>
    <Text type='secondary' style={{ fontSize: '12px' }}>
      {id}
    </Text>
  </Space>
)

// Format timeline item content
export const formatTimelineItem = (activity) => (
  <>
    <div style={{ marginBottom: '8px' }}>
      <Space>
        <Text strong>{activity.activityType}</Text>
        <span>{getStatusBadge(activity.status)}</span>
      </Space>
    </div>

    <div style={{ marginBottom: '4px' }}>
      <Space>
        <UserOutlined />
        <Text>Patient: {activity.patientName}</Text>
      </Space>
    </div>

    <div>
      <Space>
        <ClockCircleOutlined />
        <Text>
          {activity.endTime
            ? `${formatTime(activity.startTime)} - ${formatTime(activity.endTime)} (${getDuration(
                activity.startTime,
                activity.endTime
              )})`
            : `Started: ${formatTime(activity.startTime)}`}
        </Text>
      </Space>
    </div>

    {activity.notes && (
      <div style={{ marginTop: '4px', fontSize: '12px', color: 'rgba(0,0,0,0.45)' }}>{activity.notes}</div>
    )}

    <div style={{ marginTop: '4px' }}>
      <Text type='secondary'>
        Room: {activity.roomNumber}, {activity.department}
      </Text>
    </div>
  </>
)
